import { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { Form, Button, Spinner } from 'react-bootstrap'
import { UserServices } from 'services'
import { setMainContent } from 'actions'
import { toast } from 'components/common/Toast'
import { LeftArrow } from 'assets/icons/components/index'
import i18n from 'config/i18n'
import { useTranslation } from 'react-i18next'

const Password = (props) => {
  const { dispatch } = props
  const { t } = useTranslation('live', { i18n })

  const [isLoading, setIsLoading] = useState(false)
  const [inputValues, setInputValues] = useState({
    current_password: '', password: '', password_confirmation: ''
  })

  const handleOnChange = event => {
    const value = event.target.value
    const id = event.target.id
    setInputValues({ ...inputValues, [id]: value })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    try {
      setIsLoading(true)

      if (inputValues.password !== inputValues.password_confirmation) {
        throw t('Passwords do not match')
      }

      let { data, error } = await UserServices.changePassword(inputValues)

      if (data) {
        setInputValues({
          current_password: '', password: '', password_confirmation: ''
        })
        toast.success(t('Update password successfully'))
      }
      if (error) {
        throw error.message
      }
    } catch (error) {
      toast.error(error)
    }
    setIsLoading(false)
  }

  const back = () => {
    dispatch(setMainContent('dashboard'))
  }

  return (
    <div className='main-content__personal-information'>
      <div className='personal-information__container'>
        <Form className='container__form-wrapper' onSubmit={handleSubmit}>
          <Form.Group controlId='current_password'>
            <Form.Label>{t('Current password')}:</Form.Label>
            <Form.Control
              onChange={handleOnChange}
              value={inputValues.current_password}
              type='password'
              autoComplete='current-password'
              placeholder={t('Enter current password')} />
          </Form.Group>
          <Form.Group controlId='password'>
            <Form.Label>{t('New password')}:</Form.Label>
            <Form.Control
              onChange={handleOnChange}
              value={inputValues.password}
              type='password'
              autoComplete='current-password'
              placeholder={t('Enter new password')} />
          </Form.Group>
          <Form.Group controlId='password_confirmation'>
            <Form.Label>{t('Confirm new password')}:</Form.Label>
            <Form.Control
              onChange={handleOnChange}
              value={inputValues.password_confirmation}
              type='password'
              autoComplete='current-password'
              placeholder={t('Enter new password again')} />
          </Form.Group>
          <Button variant='primary' type='submit' size='lg' className='form__button'>
            {isLoading ? <Spinner
              as='span' animation='border' size='md' role='status'
            /> : t('Save')}
          </Button>
        </Form>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => ({
  user: state.connectionReducer.user,
  contentKey: state.mainContentReducer.contentKey
})

export default connect(mapStateToProps)(Password)
